
export function isMobileDevice() {
  const smallestBreakpointQuery = window.matchMedia("(max-width: 480px)");
  return smallestBreakpointQuery.matches;
}